import React from 'react';
import './AdminSidebarGroup.css';

/**
 * @param {{
 *   label: React.ReactNode,
 *   onToggleAll?: (() => void) | null,
 *   children?: React.ReactNode,
 *   className?: string
 * }} props
 */
function AdminSidebarGroup({
  label,
  onToggleAll = null,
  children,
  className = '',
}) {
  return (
    <section className={`au-sidebar-group au-scope${className ? ` ${className}` : ''}`}>
      <div className="au-sidebar-group__header">
        <span className="au-sidebar-group__label">{label}</span>
        {onToggleAll ? (
          <button type="button" className="au-sidebar-group__toggle" onClick={onToggleAll}>
            All
          </button>
        ) : null}
      </div>
      <div className="au-sidebar-group__rows">{children}</div>
    </section>
  );
}

export default AdminSidebarGroup;
